export default __webpack_public_path__ + "e8bcca5ba57a4f82a508afea7224dcc9.png";